export default __webpack_public_path__ + "static/media/selectCustomer.d514b51c.svg";